/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Placelunchflyerweek3Inputs */

const en_placelunchflyerweek3 = /** @type {(inputs: Placelunchflyerweek3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}`)
};

const de_placelunchflyerweek3 = /** @type {(inputs: Placelunchflyerweek3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`KW ${i?.week}`)
};

/**
* | output |
* | --- |
* | "Week {week}" |
*
* @param {Placelunchflyerweek3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placelunchflyerweek3 = /** @type {((inputs: Placelunchflyerweek3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placelunchflyerweek3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placelunchflyerweek3(inputs)
	return de_placelunchflyerweek3(inputs)
});
export { placelunchflyerweek3 as "placeLunchFlyerWeek" }